<template>
  <main>
    <div v-if="isBookingInProgress" class="booking-progress-overlay">
      <div class="booking-progress-card">
        <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
        <p class="mb-0 mt-3 fw-semibold">Booking in progress...</p>
        <p class="mb-0 mt-1 text-muted font-size-1">Please wait, do not refresh or go back.</p>
      </div>
    </div>

    <section v-if="bookingConfirmed" class="container mt-5 mb-15">
      <div class="booking-success-card mx-auto text-center">
        <div class="booking-success-icon mb-3">✓</div>
        <h3 class="fw-semibold mb-2">Booking confirmed</h3>
        <p class="text-muted mb-1">Your cottage reservation has been confirmed.</p>
        <p class="fw-semibold font-size-2 mb-4">
          Booking ID:
          <span class="text-primary">{{ confirmedBookingId }}</span>
        </p>
        <div class="d-flex justify-content-center gap-2 flex-wrap">
          <button
            v-if="confirmedBookingMongoId"
            type="button"
            class="btn bg-primary text-white px-4"
            @click="goToBookingDetails"
          >
            View booking
          </button>
          <button
            type="button"
            class="btn bg-gray-200 border px-4"
            @click="goToBookingList"
          >
            Back to booking list
          </button>
        </div>
      </div>
    </section>

    <form v-else @submit.prevent="bookingFormSubmit">
      <section class="container mt-4 mb-15">
        <h3 class="text-center">Book a cottage</h3>

        <div
          v-if="bookingError"
          class="alert alert-danger mx-auto"
          style="max-width: 640px"
          role="alert"
        >
          {{ bookingError }}
        </div>

        <div class="row mt-5">
          <div class="col-md-6 border-end">
            <div class="w-75 font-size-1">
              <div class="mb-3">
                <label for="" class="fw-semibold mb-2">Co-farmer</label>
                <Select2
                  v-model="form.co_farmer_id"
                  id="mySelect"
                  @select="selectedCofarmer($event)"
                  class=""
                  placeholder="Search member by name, email or phone"
                  :settings="cofarmerSelectSettings"
                >
                </Select2>
              </div>
              <div class="mb-3">
                <label for="" class="fw-semibold mb-2">Mobile number</label>
                <input
                  type="text"
                  v-model="form.mobile_number"
                  name=""
                  id=""
                  class="form-control"
                  placeholder="Must be 10digits"
                />
              </div>
              <div class="mb-3">
                <label for="" class="fw-semibold mb-2">Email address</label>
                <input
                  type="email"
                  v-model="form.email"
                  name=""
                  id=""
                  class="form-control"
                  placeholder="john@example.com"
                />
              </div>
              <div class="mb-3">
                <label for="" class="fw-semibold mb-2">Amount paid (including tax)</label>
                <input
                  type="number"
                  v-model="form.amount_paid"
                  name=""
                  id=""
                  class="form-control"
                  placeholder="Enter the amount"
                />
              </div>
              <div class="mb-3">
                <label for="" class="fw-semibold mb-2">Transaction Id</label>
                <input
                  type="text"
                  v-model="form.transaction_id"
                  name=""
                  id=""
                  class="form-control"
                  placeholder="Enter Transaction id"
                />
              </div>
              <div class="mb-3">
                <label for="" class="fw-semibold mb-2">Notes(Optional)</label>
                <textarea
                  class="form-control"
                  v-model="form.remarks"
                  id=""
                  rows="50"
                  cols="47"
                  style="height: 150px"
                  placeholder="Max 250 characters"
                ></textarea>
              </div>
            </div>
          </div>

          <div class="col-md-6 px-5">
            <div class="align-items-center" style="display: flex">
              <div class="" style="width: 200px">
                <img
                  :src="booking_details.cover_image.url"
                  class="w-100 rounded"
                />
              </div>
              <div class="ps-3">
                <p class="mb-0 font-size-2 fw-semibold">
                  {{ booking_details.retreat_name }}
                </p>
                <span class="font-size-1">{{
                  booking_details.name
                }}</span>
              </div>
            </div>
            <div class="listss mt-3">
              <p class="fw-semibold font-size-2">Booking details</p>
              <ul class="list-unstyled font-size-1 fw-medium">
                <li class="pb-2">
                  {{ dateTime(booking_details.check_in) }} -
                  {{ dateTime(booking_details.check_out) }}
                </li>
                <li class="pb-2">
                  {{ booking_details.cottage_count }} Cottages
                </li>
                <li class="pb-2">
                  {{ booking_details.adults }} adults,
                  {{ booking_details.children }} children,
                  {{ booking_details.guests }} guests,
                  {{ booking_details.pets }} pets
                </li>
              </ul>

              <p class="fw-semibold font-size-2 mb-0">Payment details</p>
              <ul class="basic-list font-size-1 fw-medium basic-pad">
                <li class="d-flex justify-content-between">
                  <span
                    >Rent - {{ booking_details.nights }} Nights x
                    {{ booking_details.cottage_count }} Cottages</span
                  >
                  <span class="">₹ {{ booking_details.total.payableAmount }}</span>
                </li>

                <li
                  class="d-flex justify-content-between"
                  v-if="applyCreditTotheBooking"
                >
                  <span
                    >Credits - {{ booking_details.nights }} Nights x
                    {{ booking_details.cottage_count }} Cottages</span
                  >
                  <span class=""
                    >{{ booking_details.credit_required }} Credits</span
                  >
                </li>
                <li class="d-flex justify-content-between">
                  <span class="text-right">
                    <button
                      type="button"
                      @click="applyCreditToBooking"
                      class="btn btn-sm text-white me-5 px-4"
                      :disabled="disableCreditBtnFunction"
                      :class="{
                        'btn-success': !applyCreditTotheBooking,
                        'btn-danger': applyCreditTotheBooking,
                      }"
                    >
                      <span v-if="applyCreditTotheBooking">
                        Remove Credit
                      </span>
                      <span v-else>Apply Credit</span>
                    </button>
                  </span>
                </li>
              </ul>
              <hr />
              <p class="d-flex justify-content-between fw-semibold">
                <span class="">Taxable Amount</span>
                <span class="">₹ {{ booking_details.total.taxableAmount }}</span>
              </p>
              <p class="d-flex justify-content-between fw-semibold">
                <span class="">Tax</span>
                <span class="">₹ {{ (form.credit_applied) ? booking_details.total.taxAmount : booking_details.total.taxAmount }}</span>
              </p>
              <p class="d-flex justify-content-between fw-semibold">
                <span class="">Payable Amount</span>
                <span class="">₹ {{ (form.credit_applied) ? booking_details.total.payableAmount : booking_details.total.payableAmount}} </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      <footer>
        <div class="fixed-bottom bg-white">
          <hr class="mt-0 border-secondary" />
          <div class="row">
            <div class="col-md-6 mb-3 ps-5">
              <button
                type="button"
                @click="cancelBtn"
                class="btn bg-gray-200 border fw-light ms-5 px-4"
                :disabled="isBookingInProgress"
              >
                Cancel
              </button>
            </div>
            <div class="col-md-6 text-end mb-3 pe-5">
              <button class="btn bg-primary text-white me-5 px-4" :disabled="isBookingInProgress">
                <span
                  v-if="isBookingInProgress"
                  class="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                {{ isBookingInProgress ? "Booking..." : "Submit" }}
              </button>
            </div>
          </div>
        </div>
      </footer>
    </form>
  </main>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      isBookingInProgress: false,
      bookingConfirmed: false,
      confirmedBookingId: "",
      confirmedBookingMongoId: "",
      bookingError: "",
      form: {
        co_farmer_id: "",
        co_farmer_current_credit: "",
        mobile_number: "",
        email: "",
        amount_paid: "",
        transaction_id: "",
        remarks: "",
        retreat_id: "",
        cottage_id: "",
        adults: 0,
        children: 0,
        guests: 0,
        pets: 0,
        check_in: "",
        check_out: "",
        credit_required: 0,
        credit_applied: false,
        bookingToken:''
      },
      selected_cofarmer: null,
      applyCreditTotheBooking: false,
      booking_details: {
        total: 0,
        cover_image: {
          url: "",
        },
        retreat_name: "",
        cottage_name: "",
        check_in: "",
        check_out: "",
        cottage_count: "",
        adults: "",
        children: "",
        guests: "",
        pets: "",
        nights: "",
        total_amount_with_credit: 0,
        total_amount_without_credit: 0,
        total_without_credit: "",
        total_with_credit: "",
        cofarmer_details: [],
      },
      disableCreditBtnFunction: true,
      disableCreditBtn: true,
    };
  },
  mounted() {
    this.checkAvailability();
  },
  computed: {
    cofarmerSelectSettings() {
      const api = this.$apiV1;
      return {
        allowClear: true,
        minimumInputLength: 2,
        ajax: {
          delay: 300,
          transport: (params, success, failure) => {
            api
              .get("/users", { params: { q: params.data.q, limit: 20 } })
              .then((res) => success(res))
              .catch((err) => failure(err));
          },
          data: (params) => ({ q: params.term }),
          processResults: (res) => ({
            results: (res.data?.data || []).map((cf) => ({
              id: cf._id,
              text: `${cf.name} - Credits - ${(cf.CurrentCredits || 0).toFixed(2)}`,
              obj: cf,
            })),
          }),
        },
      };
    },
  },

  methods: {
    cancelBtn() {
      this.$router.go(-1);
    },
    goToBookingList() {
      this.$router.push("/farm-stay/retreat/bookings");
    },
    goToBookingDetails() {
      if (this.confirmedBookingMongoId) {
        this.$router.push(`/farm-stay/booking/${this.confirmedBookingMongoId}`);
      } else {
        this.goToBookingList();
      }
    },
    bookingFormSubmit() {
      let {
        retreat_id,
        cottage_id,
        adults,
        children,
        guests,
        pets,
        check_in,
        check_out,
      } = this.$route.query;

      let {
        credit_applied,
        amount_paid,
        transaction_id,
        remarks,
        mobile_number,
        co_farmer_id,
        credit_required,
        email,
        bookingToken
      } = this.form;
      let taxDetails = this.getTaxDetails(amount_paid);
      let { total } = this.booking_details;
      let data = {
        retreat_id,
        cottage_id,
        adults,
        children,
        guests,
        email,
        pets,
        check_in: this.form.check_in || this.formatDateParam(check_in),
        check_out: this.form.check_out || this.formatDateParam(check_out),
        total,
        credit_applied,
        amount_paid: amount_paid,
        taxDetails:taxDetails,
        transaction_id: transaction_id,
        remark: remarks,
        mobile: mobile_number,
        credits_count: credit_required,
        co_farmer_id: co_farmer_id,
        bookingToken:bookingToken
      };
      this.bookingError = "";
      this.isBookingInProgress = true;
      this.$apiV1
        .post("/farm-stay/book", data)
        .then((res) => {
          this.isBookingInProgress = false;
          if (res.data.success) {
            const booking = res.data.data || {};
            this.confirmedBookingId = booking.bookingId || booking._id || "";
            this.confirmedBookingMongoId = booking._id || "";
            this.bookingConfirmed = true;
          } else {
            this.bookingError = res.data.message || "Booking failed. Please try again.";
          }
        })
        .catch((err) => {
          this.isBookingInProgress = false;
          console.log(err);
          this.bookingError =
            err?.response?.data?.message || "Booking failed. Please try again.";
        });
    },
    getTaxDetails(amountPaid) {
      let bookingDetails = this.booking_details;
      console.log(bookingDetails)
      console.log(amountPaid);
    },
    selectedCofarmer(selected) {
      const co_farmer = selected?.obj;
      if (!co_farmer) return;
      this.selected_cofarmer = co_farmer;
      this.form.mobile_number = co_farmer.phone;
      this.form.email = co_farmer.email;
      this.form.credit_applied = false;
      this.applyCreditTotheBooking = false;
      this.booking_details.total =
        this.booking_details.total_amount_without_credit;
      this.form.credit_required = 0;
      this.form.co_farmer_current_credit = co_farmer.CurrentCredits;
      if (
        this.form.co_farmer_id != "" &&
        co_farmer.CurrentCredits >= this.booking_details.credits_required
      ) {
        this.disableCreditBtnFunction = false;
      } else {
        this.disableCreditBtnFunction = true;
      }
    },
    applyCreditToBooking() {
      this.applyCreditTotheBooking = !this.applyCreditTotheBooking;
      if (
        this.applyCreditTotheBooking &&
        this.form.co_farmer_current_credit >=
          this.booking_details.credits_required
      ) {
        this.form.credit_applied = true;

        let credit_required =
          parseInt(this.booking_details.nights) *
          parseInt(this.booking_details.cottage_count);

        this.form.credit_required = this.booking_details.credit_required =
          credit_required;

        this.booking_details.total =
          this.booking_details.total_amount_with_credit;
      } else {
        this.form.credit_required = 0;
        this.booking_details.total =
          this.booking_details.total_amount_without_credit;
        this.form.credit_applied = true;
      }
    },
    dateTime(value) {
      if (value) return moment(value).format("DD-MM-YYYY");
      else return "";
    },
    formatDateParam(value) {
      if (!value) return "";
      const parsed = moment(value);
      if (parsed.isValid()) return parsed.format("YYYY-MM-DD");
      // Fallback for browser Date.toString() query values
      const fromJs = new Date(value);
      if (!Number.isNaN(fromJs.getTime())) return moment(fromJs).format("YYYY-MM-DD");
      return value;
    },
    async checkAvailability() {
      let {
        retreat_id,
        cottage_id,
        adults,
        children,
        guests,
        pets,
        check_in,
        check_out,
      } = this.$route.query;

      let data = {
        retreat_id,
        cottage_id,
        adults,
        children,
        guests,
        pets,
        check_in: this.formatDateParam(check_in),
        check_out: this.formatDateParam(check_out),
      };
      try {
        let availabilityResp = await this.$apiV1.get("/farm-stay/availability", {
          params: data,
        });

        this.booking_details = availabilityResp.data;
        this.booking_details.total =
          this.booking_details.total_amount_without_credit;
        this.booking_details.credits_required =
          this.booking_details.nights * this.booking_details.cottage_count;

        this.form.bookingToken = this.booking_details.bookingToken;
        this.form.check_in = data.check_in;
        this.form.check_out = data.check_out;
      } catch (err) {
        const message =
          err?.response?.data?.message || "Cottage is not available for the selected dates";
        this.bookingError = message;
      }
    },
  },
};
</script>
<style>
.mb-15 {
  margin-bottom: 15rem;
}
.select2-container {
  width: 100% !important;
}

.booking-progress-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.75);
}

.booking-progress-card {
  text-align: center;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 2rem 2.5rem;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.booking-success-card {
  max-width: 480px;
  margin-top: 4rem;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 2.5rem 2rem;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
}

.booking-success-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto;
  border-radius: 50%;
  background: #e8f5e9;
  color: #2e7d32;
  font-size: 1.75rem;
  line-height: 56px;
  font-weight: 700;
}
</style>